import { useState } from 'react';
import { VictoryPie } from 'victory';
import info from '../../../../../../assets/images/icons/info.svg';
import NoData from '../../../../../../components/NoData';
import OpacityAnimation from '../../../../../../components/OpacityAnimation';
import useThemeContext from '../../../../../../contexts/theme';
import { Card } from './styles';

interface StatusChartCardI {
  totalConsults: number;
  totalImplantations: number;
}

export default function ImplantationsCard({ totalConsults, totalImplantations }: StatusChartCardI) {
  const { selectedTheme } = useThemeContext();
  const [labelBeingShow, setLabelBeingShow] = useState({ description: '', value: '' });

  return (
    <Card>
      <div className="card-title">
        <div>
          Implantações ({totalImplantations} / {totalConsults})
          <img src={info} alt="" className='primaryColor info' title='É considerada uma implantação um usuário que aceitou e finalizou o processo de sua roteirização'/>
        </div>
      </div>

      {(!!totalConsults && !!totalImplantations) && (
        <>
          <OpacityAnimation>
            <div className="card-main-graph">
              <VictoryPie
                data={[
                  { x: `${totalConsults - totalImplantations > 1 ? 'Não Implantadas' : 'Não Implantada'}`, y: totalConsults - totalImplantations },
                  { x: `${totalImplantations > 1 ? 'Implantadas' : 'Implantada'}`, y: totalImplantations }
                ]}
                animate={{
                  duration: 500
                }}
                colorScale="qualitative"
                height={335}
                labelPlacement="vertical"
                labelRadius={0.1}
                labelPosition="endAngle"
                style={{
                  labels: { fontSize: 0, fill: selectedTheme === 'dark' ? '#fff' : '#000' }
                }}
                padding={{ top: 0, bottom: 10 }}
                innerRadius={110}
                padAngle={1}
                events={[{
                  target: 'data',
                  eventHandlers: {
                    onMouseOver: () => {
                      return [
                        {
                          target: 'data',
                          mutation: ({ style, data, index }) => {
                            setLabelBeingShow({ description: data[index].x, value: data[index].y });
                            return { style: Object.assign({}, style, { opacity: '0.8', cursor: 'help' }) };
                          }
                        }
                      ];
                    },
                    onMouseOut: () => {
                      return [
                        {
                          target: 'data',
                          mutation: () => {
                            setLabelBeingShow({ description: '', value: '' });
                            return null;
                          }
                        }
                      ];
                    }
                  }
                }]}
              />
              <label>
                <span>{labelBeingShow.value ? Number(labelBeingShow.value).toFixed(0) : ''}</span>
                <span>{labelBeingShow.description}</span>
              </label>
            </div>
          </OpacityAnimation>
        </>
      )}

      {(!totalImplantations) && (
        <NoData
          icon="emptyBox"
          label={(
            <>
              Não foi realizada nenhuma implantação no período selecionado
            </>
          )}
        />
      )}
    </Card>
  );
}
